"use client";

import { c as _c } from "react/compiler-runtime";
import { LocaleProvider } from "@opensea/i18n";
import { NextIntlClientProvider } from "next-intl";
export function IntlProvider(t0) {
  const $ = _c(15);
  let children;
  let locale;
  let messages;
  let rest;
  let timeZone;
  if ($[0] !== t0) {
    ({
      children,
      locale,
      messages,
      timeZone,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = locale;
    $[3] = messages;
    $[4] = rest;
    $[5] = timeZone;
  } else {
    children = $[1];
    locale = $[2];
    messages = $[3];
    rest = $[4];
    timeZone = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== locale || $[8] !== messages || $[9] !== rest || $[10] !== timeZone) {
    t1 = <NextIntlClientProvider locale={locale} messages={messages} timeZone={timeZone} {...rest}>{children}</NextIntlClientProvider>;
    $[6] = children;
    $[7] = locale;
    $[8] = messages;
    $[9] = rest;
    $[10] = timeZone;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== locale || $[13] !== t1) {
    t2 = <LocaleProvider value={locale}>{t1}</LocaleProvider>;
    $[12] = locale;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}